module.exports = __webpack_public_path__ + "static/media/decade-grid-1.479b3527.png";